const REACT_APP_BASE_URL = process.env.REACT_APP_BASE_URL || 'http://localhost:2222'
export const API_URL = REACT_APP_BASE_URL

/*
 * Erkennt die Testumgebung. Sowohl das Frontend als auch das Backend laufen dort
 * unter test.company.junior.cc - Prod ist company.junior.cc (ohne "test"). Wir
 * pruefen die aufrufende Adresse UND die Backend-URL (Build-Arg BACKEND_URL),
 * damit der Hinweis auch greift, wenn lokal gegen das Test-Backend gearbeitet wird.
 */
export const isTestEnvironment = () => {
	const host = typeof window !== 'undefined' ? window.location.hostname : ''
	return host.startsWith('test.') || /\/\/test\./.test(REACT_APP_BASE_URL)
}

/*
 * MailHog der Testumgebung ("Sammel-Postfach"). Alle ausgehenden Mails der
 * Testumgebung landen hier statt beim echten Empfaenger.
 *
 * OHNE Zugangsdaten in der Adresse: Frueher stand hier
 * "http://admin:...@52.58.13.61:8025". Chrome bricht eine von der Seite
 * ausgeloeste Navigation zu einer Adresse mit eingebetteten Zugangsdaten
 * stillschweigend ab - der Klick auf den Verweis blieb dadurch wirkungslos
 * (dieselbe Adresse von Hand eingetippt funktioniert, weil sie dann nicht von
 * der Seite kommt). Stattdessen fragt der Browser die Daten selbst ab; sie
 * stehen im Hinweis daneben.
 */
export const MAILHOG_URL = 'http://52.58.13.61:8025'

/*
 * Die Anmeldung am Sammel-Postfach stand hier bis 02.09.2026 als Konstante — und
 * damit im gebauten Bundle, das jeder ohne Anmeldung herunterladen kann:
 *
 *   curl -s https://test.company.junior.cc/static/js/main.<hash>.js | grep <passwort>
 *
 * Gegen eine Oberfläche, die nur im eigenen Netz steht, war das ohne Folgen.
 * Sobald sie über HTTPS erreichbar ist, wäre die Anmeldung damit öffentlich und
 * der Schutz nur noch die Adresse — die daneben steht.
 *
 * Sie kommt jetzt vom Server, aus `GET /admin/options/email-test`
 * (`viewerCredentials`). Diese Route liegt hinter dem Admin-Wächter: Die
 * Zugangsdaten sieht, wer angemeldet und Administrator ist. Zu finden sind sie
 * unter Einstellungen → E-Mail-Versand.
 *
 * Die **Adresse** darf hier bleiben: Sie ist keine Anmeldung, und der
 * Hinweisstreifen der Testumgebung braucht sie in jeder Rolle.
 */
